import React from 'react'
import emailjs from '@emailjs/browser';
import Footer from '../components/Footer'
import Header from '../components/Header'
import LoadingSpinner from '../components/LoadingSpinner'
import '../componentcss/Contact.css'
import '../componentcss/LoadingSpinner.css'
// npm install @mui/icons-material
// npm install @mui/material
// npm i @emailjs/browser
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import { useDispatch, useSelector } from 'react-redux'
import { useState, useRef, useEffect } from 'react'
import { actionAddClient } from '../redux/actions/client'
import { Modal, Button } from 'react-bootstrap'
import ContactHeader from '../images/ContactHeader.jpeg'
import { FormHelperText, InputLabel, MenuItem } from '@mui/material';
import CSSTextField from '../components/CSSTextField'
import CSSSelect from '../components/CSSSelect'
// npm install -g npm (new npm version install)
import { storage } from '../firebase'
import { ref, uploadBytesResumable } from 'firebase/storage'
import { getDownloadURL } from 'firebase/storage';
// npm install react-date-picker
import DatePicker from 'react-date-picker'

function Contact() {
    
    // Email.js
    const form = useRef();
    
    // Current Date Formatting
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = today.getFullYear();
    const hrs = String(today.getHours()+ 0).padStart(2, '0');
    const min = String(today.getMinutes()+ 1).padStart(2, '0');
    const Time = yyyy + '/' + mm + '/' + dd + ' ' + hrs+ ':' + min;

    

    // Redirect function for after form submission
    function redirect_Main() {
        var tID = setTimeout(function () {
            window.location.href = "/";
            window.clearTimeout(tID);
            // clear time out.
        }, 2000);
    }
    // Dispatch for Redux 
    const dispatch = useDispatch()

    // useState Hooks to Capture Client Input
    const [show, setShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [fname, setFName] = useState('');
    const [age, setAge] = useState('0 - 15');
    const [lname, setLName] = useState('');
    const [consultation, setConsultation] = useState('');
    const [size, setSize] = useState(0);
    const [eventDate, setEventDate] = useState('');
    const [email, setEmail] = useState('');
    const [existingnew, setExistingnew] = useState('');
    const [fitting, setFitting] = useState('');
    const [phone, setPhone] = useState('');
    const [shipping, setShipping] = useState('');
    const [comments, setComments] = useState('');
    const [budget, setBudget] = useState('');
    const [height, setHeight] = useState('');
    const [color, setColor] = useState('#000000');
    const [fabric, setFabric] = useState('');
    const [upload1, setUpload1] = useState('')
    const [upload2, setUpload2] = useState('')
    const [upload3, setUpload3] = useState('')
    const [upload4, setUpload4] = useState('')
    const [upload5, setUpload5] = useState('')
    const [upload6, setUpload6] = useState('')
    const [purpose, setPurpose] = useState({
        Birthday: false,
        WeddingGuest: false,
        Prom: false,
        Wedding: false,
        Reception: false,
        Anniversary: false,
        RedCarpet: false,
        Graduation: false,
        SisofBride: false,
        MotherofBride: false,
        EveningWear: false,
        Other: false
    });

    // Get client from global state
    const client = useSelector(state => state.client)

    // Close dropdowns on scroll
    useEffect(() => {
        const handleScroll = () => {
            // Close any open Material-UI dropdowns by removing focus
            if (document.activeElement && document.activeElement.blur) {
                document.activeElement.blur();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Deploys "Submit Successful" Modal, triggered by form submission via handleSubmit function
    const handleShow = () => setShow(true);

    // Close Modal and redirect to Home page
    const handleClose = () => {
        setShow(false)
        redirect_Main()
    };

    // Validation function
    const validateForm = () => {
        const newErrors = {};
        
        if (!fname.trim()) newErrors.fname = 'First name is required';
        if (!lname.trim()) newErrors.lname = 'Last name is required';
        if (!email.trim()) newErrors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(email)) newErrors.email = 'Email is invalid';
        if (!phone.trim()) newErrors.phone = 'Phone number is required';
        if (!budget) newErrors.budget = 'Budget selection is required';
        if (!height) newErrors.height = 'Height selection is required';
        if (!consultation) newErrors.consultation = 'Consultation preference is required';
        if (!shipping) newErrors.shipping = 'Shipping preference is required';
        if (!upload1 || !upload2) newErrors.uploads = 'At least 2 inspiration photos are required';
        if (!upload6) newErrors.bodyPhoto = 'Full-body photo is required';
        if (!comments.trim() || comments.length < 5) newErrors.comments = 'Comments must be at least 5 characters';
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Capture Client Info and Post To Redux & Firebase
    // Notify owner of contact
    const handleSubmit = e => {
        e.preventDefault();
        
        if (!validateForm()) {
            return;
        }

        setIsLoading(true);

        // Capture Info from Contact Local State 
        client.FName = fname;
        client.Time = Time
        client.LName = lname;
        client.Age = age;
        client.Consultation = consultation;
        client.Size = size;
        client.EMail = email;
        client.Existingnew = existingnew;
        client.Fitting = fitting;
        client.Phone = phone;
        client.Shipping = shipping;
        client.Purpose = purpose;
        client.Comments = comments;
        client.Budget = budget;
        client.Height = height;
        client.Color = color;
        client.Fabric = fabric;
        client.EventDate = eventDate
        // Turnery Statements
        // If pictures have been uploaded, use the name of the file for the New Client Form in the Firestore DB
        client.Upload1 = upload1.name ? upload1.name : null;
        client.Upload2 = upload2.name ? upload2.name : null;
        client.Upload3 = upload3.name ? upload3.name : null;
        client.Upload4 = upload4.name ? upload4.name : null;
        client.Upload5 = upload5.name ? upload5.name : null;
        client.ClientPic = upload6.name ? upload6.name : null;

        // Create Storage references for each photo in Firebase Storage with file path for organization.
        const storageRef1 = ref(storage, (`images/${lname}-${fname}/InspirationPhoto/${upload1.name}`));
        const storageRef2 = ref(storage, (`images/${lname}-${fname}/InspirationPhoto/${upload2.name}`));
        const storageRef3 = ref(storage, (`images/${lname}-${fname}/InspirationPhoto/${upload3.name}`));
        const storageRef4 = ref(storage, (`images/${lname}-${fname}/InspirationPhoto/${upload4.name}`));
        const storageRef5 = ref(storage, (`images/${lname}-${fname}/InspirationPhoto/${upload5.name}`));
        const storageRef6 = ref(storage, (`images/${lname}-${fname}/ClientPhoto/${upload6.name}`));

        // Send each uploaded photo to Firebase
        const uploadTask1 = uploadBytesResumable(storageRef1, upload1);
        uploadTask1.on(
            "state_changed",
            (snapshot) => { },
            (err) => {}, // Error handled silently - user sees UI feedback
            () => {
                getDownloadURL(uploadTask1.snapshot.ref)
            }
        );

        const uploadTask2 = uploadBytesResumable(storageRef2, upload2);
        uploadTask2.on(
            "state_changed",
            (snapshot) => { },
            (err) => {}, // Error handled silently - user sees UI feedback
            () => {
                getDownloadURL(uploadTask2.snapshot.ref)
            }
        );

        const uploadTask3 = uploadBytesResumable(storageRef3, upload3);
        uploadTask3.on(
            "state_changed",
            (snapshot) => { },
            (err) => {}, // Error handled silently - user sees UI feedback
            () => {
                getDownloadURL(uploadTask3.snapshot.ref)
            }
        );

        const uploadTask4 = uploadBytesResumable(storageRef4, upload4);
        uploadTask4.on(
            "state_changed",
            (snapshot) => { },
            (err) => {}, // Error handled silently - user sees UI feedback
            () => {
                getDownloadURL(uploadTask4.snapshot.ref)
            }
        );

        const uploadTask5 = uploadBytesResumable(storageRef5, upload5);
        uploadTask5.on(
            "state_changed",
            (snapshot) => { },
            (err) => {}, // Error handled silently - user sees UI feedback
            () => {
                getDownloadURL(uploadTask5.snapshot.ref)
            }
        );

        const uploadTask6 = uploadBytesResumable(storageRef6, upload6);
        uploadTask6.on(
            "state_changed",
            (snapshot) => { },
            (err) => {}, // Error handled silently - user sees UI feedback
            () => {
                getDownloadURL(uploadTask6.snapshot.ref)
            }
        );

        // Send E-Mail notification of customer contact to owner via email.js
        emailjs.sendForm('service_jp95jt9', 'template_ptgk4z9', form.current, '0GOH6Mh_VqTqgJVB4')
            .then((result) => {
            // console.log(result.text);
            setIsLoading(false);
        }, (error) => {
            // console.log(error.text);
            setIsLoading(false);
        });

        // Submit info as "client" and dispatch to redux for global state
        dispatch(actionAddClient(client))

        // deploy "Sumbit Successful" Modal
        handleShow()
        // Redirect to Home page on close
    }

    return (
        <div className="contact">
            < Header />
            <div className="contact-body">
                <div className='contact-form text-center'>

                    <div className='contact-video'>

                        <img className='contact-header-image' src={ContactHeader} alt="SLR Couture Design" />

                        <div className='contact-intro'>
                            <p>
                                SLR Couture offers custom-made gowns for clients who value unique designs and exceptional workmanship. Every piece is created with careful consideration given to your event, fit, and personal aesthetic.
                            </p>
                            <p>
                                Our services include bridal, prom, reception, and special-event gowns. Custom gown pricing starts at $1,500 and is determined by the occasion, level of design detail, fabric choice, and required production time frame.
                            </p>
                            <p>
                                To begin the process, please complete the form below. Submission of this form is required prior to scheduling a consultation and allows us to review your request and confirm availability.
                            </p>
                            <p>
                                After your information has been reviewed, you will receive a custom price estimate along with details on the next steps if your request can be accommodated. Submissions that are incomplete or outside the scope of our services may not receive a response.
                            </p>
                            <p>
                                Please double check that your contact details are entered accurately. Responses are typically sent within 1–2 business days.
                            </p>
                            <p>
                                To ensure the highest standard of quality, SLR Couture works with a limited number of custom clients per season. We appreciate your interest and look forward to learning more about your custom request.
                            </p>
                        </div>

                        <h4 className='contact-text'>Please Complete The Form Below To Request A Quote For Your Custom Design.</h4>
                        <KeyboardDoubleArrowDownIcon className='arrow' />
                    </div>
                    <form ref={form} className="contact-form-inputs" name="Contact" onSubmit={handleSubmit}>
                        <fieldset>
                            <br />
                            <label htmlFor="contact-names" className="form-check">Name </label>
                            <div className="contact-names">
                                <div className="form-check">
                                    <CSSTextField id="fnameinput" label="First" variant="outlined" type="text" placeholder="Your First Name" value={fname} name='user_name_first' onChange={e => setFName(e.target.value)} required />
                                </div>
                                <div className="form-check">
                                    <CSSTextField id="lnameinput" label="Last" variant="outlined" type="text" placeholder="Your Last Name" value={lname} name='user_name_last'onChange={e => setLName(e.target.value)} required />
                                </div>
                            </div>
                        </fieldset>
                        <br />
                        <fieldset>
                            <label htmlFor="contact-details" className="form-check">Contact Details </label>
                            <div className="contact-details">
                                <div className="form-check">
                                    <CSSTextField id="phoneinput" label="Phone" variant="outlined" type="tel" placeholder="Your Phone Number" value={phone} onChange={e => setPhone(e.target.value)} required />
                                </div>

                                <div className="form-check">
                                    <CSSTextField label="E-Mail" variant="outlined" type="email" id="emailinput" placeholder="Your E-Mail Address" value={email} name='user_email'onChange={e => setEmail(e.target.value)} required />
                                </div>
                            </div>
                        </fieldset>

                        <fieldset >
                            <div className="contact-dropdown">
                                <div className="selector form-check">
                                    <InputLabel className="form-check">Size <span className="required-asterisk">*</span></InputLabel>
                                    <CSSSelect
                                        className="form-check"
                                        name="Select Your Dress Size"
                                        id="size-selector"
                                        value={size}
                                        onChange={e => setSize(e.target.value)}
                                        label="Size"
                                        MenuProps={{
                                            disablePortal: true,
                                            disableScrollLock: true,
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            },
                                            transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'left',
                                            },
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200,
                                                    position: 'absolute'
                                                }
                                            }
                                        }}
                                    >
                                        <MenuItem value={0} > 0 </MenuItem>
                                        <MenuItem value={2} > 2 </MenuItem>
                                        <MenuItem value={4} > 4 </MenuItem>
                                        <MenuItem value={6} > 6 </MenuItem>
                                        <MenuItem value={8} > 8 </MenuItem>
                                        <MenuItem value={10} > 10 </MenuItem>
                                        <MenuItem value={12} > 12 </MenuItem>
                                        <MenuItem value={14} > 14 </MenuItem>
                                        <MenuItem value={16} > 16 </MenuItem>
                                    </CSSSelect>
                                    <FormHelperText className="text-center" style={{ color: '#BCCBC9' }}> Select Your Dress Size </FormHelperText>
                                </div>

                                <div className="selector form-check">
                                    <InputLabel className="form-check"> Age Range <span className="required-asterisk">*</span> </InputLabel>
                                    <CSSSelect
                                        className="form-check"
                                        name="Select Your Age Range"
                                        id="age-selector"
                                        label="Age *"
                                        value={age}
                                        onChange={e => setAge(e.target.value)}
                                        MenuProps={{
                                            disablePortal: true,
                                            disableScrollLock: true,
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            },
                                            transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'left',
                                            },
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200,
                                                    position: 'absolute'
                                                }
                                            }
                                        }}
                                    >
                                        <MenuItem value='0 - 15'> 0 - 15 </MenuItem>
                                        <MenuItem value='16 - 21' > 16 - 21 </MenuItem>
                                        <MenuItem value='22 - 27' > 22 - 27 </MenuItem>
                                        <MenuItem value='28 - 34' > 28 - 34 </MenuItem>
                                        <MenuItem value='35 - 40' > 35 - 40 </MenuItem>
                                        <MenuItem value='41 - 49' > 41 - 49 </MenuItem>
                                        <MenuItem value='50 +' > 50 + </MenuItem>
                                    </CSSSelect>
                                    <FormHelperText className="text-center" style={{ color: '#BCCBC9' }}> Select Your Age Range </FormHelperText>

                                </div>

                                <div className="selector form-check">
                                    <InputLabel className="form-check">Budget <span className="required-asterisk">*</span></InputLabel>
                                    <CSSSelect
                                        className="form-check"
                                        name="Select Your Budget"
                                        id="budget-selector"
                                        label="Budget"
                                        value={budget}
                                        onChange={e => setBudget(e.target.value)}
                                        MenuProps={{
                                            disablePortal: true,
                                            disableScrollLock: true,
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            },
                                            transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'left',
                                            },
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200,
                                                    position: 'absolute'
                                                }
                                            }
                                        }}
                                    >
                                        <MenuItem value='$1,500 - $1,999' > $1,500 - $1,999 </MenuItem>
                                        <MenuItem value='$2,000 - $2,999' > $2,000 - $2,999 </MenuItem>
                                        <MenuItem value='$3,000 - $3,999' > $3,000 - $3,999 </MenuItem>
                                        <MenuItem value='$4,000 - $4,999' > $4,000 - $4,999 </MenuItem>
                                        <MenuItem value='$5,000 - $9,999' > $5,000 - $9,999 </MenuItem>
                                        <MenuItem value='$10,000+' > $10,000+ </MenuItem>
                                    </CSSSelect>
                                    <FormHelperText className="text-center " style={{ color: '#BCCBC9' }}>Select Dress Budget </FormHelperText>

                                </div>

                                <div className="selector form-check">
                                    <InputLabel className="form-check">Height <span className="required-asterisk">*</span></InputLabel>
                                    <CSSSelect
                                        className="form-check"
                                        name="Select Your Budget"
                                        id="height-selector"
                                        label="Height"
                                        value={height}
                                        onChange={e => setHeight(e.target.value)}
                                        MenuProps={{
                                            disablePortal: true,
                                            disableScrollLock: true,
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            },
                                            transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'left',
                                            },
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 200,
                                                    position: 'absolute'
                                                }
                                            }
                                        }}
                                    >

                                        <MenuItem value={' 4\' 10" & Below'}> 4'10" & Below </MenuItem>
                                        <MenuItem value={' 4\' 11" '}> 4'11" </MenuItem>
                                        <MenuItem value={' 5\' 0" '}> 5' 0" </MenuItem>
                                        <MenuItem value={' 5\' 1" '}> 5' 1" </MenuItem>
                                        <MenuItem value={' 5\' 2" '}> 5' 2" </MenuItem>
                                        <MenuItem value={' 5\' 3" '}> 5' 3" </MenuItem>
                                        <MenuItem value={' 5\' 4" '}> 5' 4" </MenuItem>
                                        <MenuItem value={' 5\' 5" '}> 5' 5" </MenuItem>
                                        <MenuItem value={' 5\' 6" '}> 5' 6" </MenuItem>
                                        <MenuItem value={' 5\' 7" '}> 5' 7" </MenuItem>
                                        <MenuItem value={' 5\' 8" '}> 5' 8" </MenuItem>
                                        <MenuItem value={' 5\' 9" '}> 5' 9" </MenuItem>
                                        <MenuItem value={' 5\' 10" '}> 5' 10" </MenuItem>
                                        <MenuItem value={' 5\' 11" '}> 5' 11" </MenuItem>
                                        <MenuItem value={' 6\' 0" '}> 6' 0" </MenuItem>
                                        <MenuItem value={' 6\' 1" '}> 6' 1" </MenuItem>
                                        <MenuItem value={' 6\' 2" '}> 6' 2" </MenuItem>
                                        <MenuItem value={' 6\' 3" '}> 6' 3" </MenuItem>
                                        <MenuItem value={' 6\' 4" '}> 6' 4" </MenuItem>
                                        <MenuItem value={' 6\' 5" & Above'}> 6' 5" & Above </MenuItem>
                                    </CSSSelect>
                                    <FormHelperText className="text-center" style={{ color: '#BCCBC9' }}>Select Your Height</FormHelperText>

                                </div>

                            </div>
                        </fieldset>

                        <fieldset>

                            <label htmlFor="outfit-selector" id="outfit-selector">Purpose of Outfit <br /> (You Can Choose More Than One Option) </label>
                            <br />
                            <p className="form-check form-check-inline">
                                <input type="checkbox" className="form-check-input" onChange={e => setPurpose({ ...purpose, Birthday: (!purpose.Birthday) })} />
                                <label className="form-check-label label-input">Birthday</label>
                            </p>
                            <p className="form-check form-check-inline">
                                <input type="checkbox" className="form-check-input" onChange={e => setPurpose({ ...purpose, WeddingGuest: (!purpose.WeddingGuest) })} />
                                <label className="form-check-label label-input"> Wedding Guest</label>
                            </p>
                            <p className="form-check form-check-inline">
                                <input type="checkbox" className="form-check-input" onChange={e => setPurpose({ ...purpose, Prom: (!purpose.Prom) })} />
                                <label className="form-check-label label-input"> Prom</label>
                            </p>
                            <p className="form-check form-check-inline">
                                <input type="checkbox" className="form-check-input" onChange={e => setPurpose({ ...purpose, Wedding: (!purpose.Wedding) })} />
                                <label className="form-check-label label-input"> Wedding</label>
                            </p>
                            <p className="form-check form-check-inline">
                                <input type="checkbox" className="form-check-input" onChange={e => setPurpose({ ...purpose, Reception: (!purpose.Reception) })} />
                                <label className="form-check-label label-input"> Reception Dress</label>
                            </p>
                            <p className="form-check form-check-inline">
                                <input type="checkbox" className="form-check-input" onChange={e => setPurpose({ ...purpose, Anniversary: (!purpose.Anniversary) })} />
                                <label className="form-check-label label-input"> Anniversary Dress</label>
                            </p>
                            <p className="form-check form-check-inline">
                                <input type="checkbox" className="form-check-input" onChange={e => setPurpose({ ...purpose, RedCarpet: (!purpose.RedCarpet) })} />
                                <label className="form-check-label label-input"> Red Carpet</label>
                            </p>
                            <p className="form-check form-check-inline">
                                <input type="checkbox" className="form-check-input" onChange={e => setPurpose({ ...purpose, Graduation: (!purpose.Graduation) })} />
                                <label className="form-check-label label-input">  Graduation</label>
                            </p>
                            <p className="form-check form-check-inline">
                                <input type="checkbox" className="form-check-input" onChange={e => setPurpose({ ...purpose, SisofBride: (!purpose.SisofBride) })} />
                                <label className="form-check-label label-input">  Sister Of Bride/Groom</label>
                            </p>
                            <p className="form-check form-check-inline">
                                <input type="checkbox" className="form-check-input" onChange={e => setPurpose({ ...purpose, MotherofBride: (!purpose.MotherofBride) })} />
                                <label className="form-check-label label-input">Mother of Bride/Groom</label>
                            </p>
                            <p className="form-check form-check-inline">
                                <input type="checkbox" className="form-check-input" onChange={e => setPurpose({ ...purpose, EveningWear: (!purpose.EveningWear) })} />
                                <label className="form-check-label label-input">  Evening Wear</label>
                            </p>
                            <p className="form-check form-check-inline">
                                <input type="checkbox" className="form-check-input" onChange={e => setPurpose({ ...purpose, Other: (!purpose.Other) })} />
                                <label className="form-check-label label-input">  Other</label>
                            </p>

                        </fieldset>

                        <fieldset>
                            <label htmlFor="event-date" id="event-date">Event Date </label>
                            <br/>
                            <DatePicker 
                                value={eventDate} 
                                className="form-check date-picker" 
                                onChange={(date) => {
                                    setEventDate(date);
                                    // Force close calendar by finding and hiding it
                                    setTimeout(() => {
                                        const calendar = document.querySelector('.react-calendar');
                                        if (calendar) {
                                            calendar.style.display = 'none';
                                        }
                                    }, 50);
                                }}
                                onCalendarOpen={() => {
                                    // Show calendar when it opens
                                    setTimeout(() => {
                                        const calendar = document.querySelector('.react-calendar');
                                        if (calendar) {
                                            calendar.style.display = 'block';
                                        }
                                    }, 10);
                                }}
                            />
                        </fieldset>

                        <fieldset>
                            <label htmlFor="design-selector" id="design-selector">Existing or New Design? </label>
                            <br />
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="design-selector" id="NewDesign" value={existingnew} onChange={e => setExistingnew("New Design")} />
                                <label htmlFor="NewDesign" className="label-input">
                                    New Design
                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="design-selector" id="ExistingDesign" value={existingnew} onChange={e => setExistingnew("Existing Design")} />
                                <label htmlFor="ExistingDesign" className="label-input">
                                    Existing Design
                                </label>
                            </div>

                        </fieldset>

                        <fieldset>
                            <label htmlFor="ColorSelector" id="ColorSelector">Select Dress Color & Fabric <br /> (Please Be As Accurate As Possible)</label>
                            <br />
                            <span>Color</span>
                            <div className="form-check">

                                <input type="color" name="color-selector" id="ColorSelector" value={color} onChange={e => setColor(e.target.value)} />
                            </div>

                            <div className="selector form-check">
                                <InputLabel className="form-check">Fabric </InputLabel>
                                <CSSSelect
                                    className="form-check"
                                    name="Select Your Fabric"
                                    id="Fabric-selector"
                                    label="Fabric"
                                    value={fabric}
                                    onChange={e => setFabric(e.target.value)}
                                    MenuProps={{
                                        disablePortal: true,
                                        disableScrollLock: true,
                                        anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        },
                                        transformOrigin: {
                                            vertical: 'top',
                                            horizontal: 'left',
                                        },
                                        PaperProps: {
                                            style: {
                                                maxHeight: 200,
                                                position: 'absolute'
                                            }
                                        }
                                    }}
                                >
                                    <MenuItem value='Not Sure' > Not Sure </MenuItem>
                                    <MenuItem value='Ankara' > Ankara </MenuItem>
                                    <MenuItem value='Beaded Rhinestone Lace'> Beaded Rhinestone Lace </MenuItem>
                                    <MenuItem value='Charmeuse' > Charmeuse </MenuItem>
                                    <MenuItem value='Chiffon' > Chiffon </MenuItem>
                                    <MenuItem value='Crepe' > Crepe </MenuItem>
                                    <MenuItem value='Embroidered Lace' > Embroidered Lace </MenuItem>
                                    <MenuItem value='Illusion Mesh' > Illusion Mesh </MenuItem>
                                    <MenuItem value='Mikado' > Mikado </MenuItem>
                                    <MenuItem value='Organza' > Organza </MenuItem>
                                    <MenuItem value='Satin' > Satin </MenuItem>
                                    <MenuItem value='Sequin' > Sequin </MenuItem>
                                    <MenuItem value='Stretch Crepe' > Stretch Crepe </MenuItem>
                                    <MenuItem value='Stretch Velvet' > Stretch Velvet </MenuItem>
                                    <MenuItem value='Tulle' > Tulle </MenuItem>
                                </CSSSelect>
                                <FormHelperText className="text-center" style={{ color: '#BCCBC9' }}>Select Dress Fabric </FormHelperText>

                            </div>
                        </fieldset>

                        <fieldset>
                            <label htmlFor="fitting-selector" id="fitting-selector">Available For A Fitting In Our Seattle Studio?</label>
                            <br />
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="fitting-selector" value={fitting} onChange={e => setFitting("Seattle Fitting")} id="Yes" />
                                <label htmlFor="Yes" className="label-input">
                                    Yes
                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="fitting-selector" value={fitting} onChange={e => setFitting("No Fitting")} id="No" />
                                <label htmlFor="No" className="label-input">
                                    No
                                </label>
                            </div>
                        </fieldset>

                        <fieldset>
                            <label htmlFor="shipping-selector" id="shipping-selector">Shipping Information</label>
                            <br />
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="shipping-selector" id="Local" value={shipping} onChange={e => setShipping("Local Shipping")} />
                                <label htmlFor="Local" className="label-input">
                                    Local (U.S.)
                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="shipping-selector" id="International" value={shipping} onChange={e => setShipping("International Shipping")} />
                                <label htmlFor="International" className="label-input">
                                    International
                                </label>
                            </div>
                        </fieldset>

                        <fieldset>
                            <label htmlFor="consultation-selector" id="consultation-selector">Consultation Preference</label>
                            <p>(Consultation Fee Due Upon Scheduling)</p>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="consultation-selector" id="inPerson" value={consultation} onChange={e => setConsultation("In-Person Consultation")} />
                                <label htmlFor="inPerson" className="label-input">
                                    In Person
                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input" type="radio" name="consultation-selector" id="Remote" value={consultation} onChange={e => setConsultation("Remote Consultation")} />
                                <label htmlFor="Remote" className="label-input">
                                    Remote
                                </label>
                            </div>

                        </fieldset>

                        <fieldset>
                            <label>Upload 1 Full-Body Photo <span className="required-asterisk">*</span></label>
                            <p>(Max Size: 10 MB)</p>
                            <div className="inspiration">
                                <input className="pic-input"
                                    id="fileinput6"
                                    type="file"
                                    
                                    onChange={e => {
                                        if (e.target.files[0].size > 10485760) {
                                            alert('Chosen Image File Is Too Large.  Please Select A Different File Or Modify File To Meet 10 MB Size Requirement Before Upload.');
                                            setUpload6(null);
                                            document.getElementById('fileinput6').value = ''
                                        } else {
                                            setUpload6(e.target.files[0]);
                                        }
                                        
                                    }} required />

                            </div>

                        </fieldset>
                        <br />
                        
                        <fieldset>
                            <label>Upload Up To 5 Garment Inspiration Photos <span className="required-asterisk">*</span></label>
                            <p style={{marginBottom: '0'}}>(Max Size: 10 MB)</p>
                            <p style={{color: 'red'}}>AT LEAST 2 REQUIRED</p>
                            <p>Please upload reference images that best represent your desired design. You may include any additional details in the field below.</p>
                            <div className="inspiration">
                                <input className="pic-input"
                                    id="fileinput1"
                                    type="file"
                                    
                                    onChange={e => {
                                        if (e.target.files[0].size > 10485760) {
                                            alert('Chosen Image File Is Too Large.  Please Select A Different File Or Modify File To Meet 10 MB Size Requirement Before Upload.');
                                            setUpload1(null);
                                            document.getElementById('fileinput1').value = ''
                                        } else {
                                            setUpload1(e.target.files[0]);
                                        }
                                    }} required />

                                <input className="pic-input"
                                    id="fileinput2"
                                    type="file"
                                    
                                    onChange={e => {
                                        if (e.target.files[0].size > 10485760) {
                                            alert('Chosen Image File Is Too Large.  Please Select A Different File Or Modify File To Meet 10 MB Size Requirement Before Upload.');
                                            setUpload2(null);
                                            document.getElementById('fileinput2').value = ''
                                        } else {
                                            setUpload2(e.target.files[0]);
                                        }
                                    }} required/>
                                <input className="pic-input"
                                    id="fileinput3"
                                    type="file"
                                    
                                    onChange={e => {
                                        if (e.target.files[0].size > 10485760) {
                                            alert('Chosen Image File Is Too Large.  Please Select A Different File Or Modify File To Meet 10 MB Size Requirement Before Upload.');
                                            setUpload3(null);
                                            document.getElementById('fileinput3').value = ''
                                        } else {
                                            setUpload3(e.target.files[0]);

                                        }
                                    }} />
                                <input className="pic-input"
                                    id="fileinput4"
                                    type="file"
                                    
                                    onChange={e => {
                                        if (e.target.files[0].size > 10485760) {
                                            alert('Chosen Image File Is Too Large.  Please Select A Different File Or Modify File To Meet 10 MB Size Requirement Before Upload.');
                                            setUpload4(null);
                                            document.getElementById('fileinput4').value = ''
                                        } else {
                                            setUpload4(e.target.files[0]);
                                        }
                                    }} />
                                <input className="pic-input"
                                    id="fileinput5"
                                    type="file"
                                    
                                    onChange={e => {
                                        if (e.target.files[0].size > 10485760) {
                                            alert('Chosen Image File Is Too Large.  Please Select A Different File Or Modify File To Meet 10 MB Max Size Requirement Before Upload.');
                                            setUpload5(null);
                                            document.getElementById('fileinput5').value = ''
                                        } else {
                                            setUpload5(e.target.files[0]);
                                        }
                                    }} />
                            </div>
                        </fieldset>
                        <br />

                        
                        <div className="col-md-6 comment_box">
                            <textarea name="comments" cols="50" rows="10" placeholder="Inquiry/Comments/Notes"
                                required minLength={5} maxLength={500}
                                className="form-check comments" onChange={e => setComments(e.target.value)} />
                        </div>
                        <br />

                        <div>
                            {isLoading ? (
                                <LoadingSpinner />
                            ) : (
                                <button type="submit" className="contact-button" onSubmit={handleSubmit}>Submit</button>
                            )}
                            {errors.fname && <div className="error-message">{errors.fname}</div>}
                            {errors.lname && <div className="error-message">{errors.lname}</div>}
                            {errors.email && <div className="error-message">{errors.email}</div>}
                            {errors.phone && <div className="error-message">{errors.phone}</div>}
                            {errors.budget && <div className="error-message">{errors.budget}</div>}
                            {errors.height && <div className="error-message">{errors.height}</div>}
                            {errors.consultation && <div className="error-message">{errors.consultation}</div>}
                            {errors.shipping && <div className="error-message">{errors.shipping}</div>}
                            {errors.uploads && <div className="error-message">{errors.uploads}</div>}
                            {errors.bodyPhoto && <div className="error-message">{errors.bodyPhoto}</div>}
                            {errors.comments && <div className="error-message">{errors.comments}</div>}
                        </div>
                        <br />

                        <Modal size="md" show={show} onHide={handleClose}>
                            <Modal.Header closeButton>
                                <Modal.Title>Submission Successful!</Modal.Title>
                            </Modal.Header>
                            <Modal.Body >
                                Thank you for choosing SLR Couture!  We have received your information and will be in touch with you soon! <br /><br /> Upon closing this window, you will be redirected to our home page.
                            </Modal.Body>

                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleClose}>
                                    Exit
                                </Button>
                            </Modal.Footer>
                        </Modal>

                    </form>
                </div>
            </div>
            < Footer />
        </div>

    )
}

export default Contact
